import { createAsyncThunk } from '@reduxjs/toolkit';

import { IMetaTag } from '.';
import { APIDataProvider, ApiPaths, TApiResponse } from '../../../api';

export interface IGetMetaTagByPath {
  path: string;
}

const apiDataProvider = new APIDataProvider();

export const getMetaTags = createAsyncThunk(
  '/meta-tags/get',
  async (data: IGetMetaTagByPath) => {
    const response = await apiDataProvider.post<TApiResponse<IMetaTag>>(
      `${ApiPaths.metaTags}`,
      data
    );

    return response.data;
  }
);
